/**
 * @file 更多列表
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';

import TextCardGroup from '../../../../components/text-card/TextCardGroup';
import learningPaddleData from './learningPaddleData';


const LearningPaddle: React.FC = () => {
    return (
        <TextCardGroup
            className="paddle-learning-paddle"
            option={learningPaddleData}
        />
    );
};

export default LearningPaddle;
